<template>
    <div class="layout minimal">
        <div class="cont">
            <div>
                <div class="logo-container">
                    <router-link :to="{ name: 'home', query: { site_type: 'divas' } }" class="logo">
                    </router-link>
                    <router-link :to="{ name: 'home', query: { site_type: 'chads' } }" class="chads-logo">
                    </router-link>
                </div>
                <slot />
            </div>
        </div>
        <slot name="after" />
    </div>
</template>

<script>
import Footer from "../components/Footer";

export default {
    components: {
        Footer,
    }
}
</script>

<style scoped lang="scss">
@import './../styles/variables';

.layout.minimal {

    .cont {
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--pallete_clear_text_color);
        min-height: 100vh;

        &>div {
            display: block;
        }

        .logo-container {
            padding: 1em;
            display: flex;
            justify-content: center;

            .logo,
            .chads-logo {
                display: block;
                margin: 0;
                height: 50px;
                // min-width: 400px;
                background-image: $DIVAS-IMG-LOGO;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center center;
            }

            .logo {
                width: 285px;
                @media(max-width: 500px) {
                    width: 62%;
                }
            }

            .chads-logo {
                background-image: $CHAD-IMG-LOGO;
                width: 178px;
                @media(max-width: 500px) {
                    width: 38%;
                }
            }
        }
    }
}
</style>
